// import logo from './logo.svg';
import './App.css';

import logo from "./Soul and Life -transparent.png"
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} alt="logo" height={200}/>

        <h1>
          Soulife.app
        </h1>
        <h3>
        <i>Connecting Your Soul to Your Life! </i>
        </h3>
        <h3>... Coming soon</h3>
        {/* <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a> */}
      </header>
    </div>
  );
}

export default App;
